import { DEFAULT_CREATOR_THEME } from "../constants/Theme.constants";
import { ICreatorTheme } from "../theme.interface";

export const getColorsFromCreatorTheme = (theme?: ICreatorTheme) =>
  theme?.colors || DEFAULT_CREATOR_THEME.colors;
